"use client";

import { Box, Grid, Typography } from "@mui/material";
import {
  allRounderIcon,
  ballIcon,
  batIcon,
  keeperIcon,
  player,
  squadPlayerBg,
} from "../../../Assets";
import { mapHighestLevelToCategory } from "../../../Utils/helperFunctions";

const PlayerCard = ({ item }: { item: any }) => (
  <Box sx={{ position: "relative", mb: "1vw", pr: "1vw" }}>
    <img
      src={squadPlayerBg}
      alt="bg"
      style={{ width: "100%", height: "100%", position: "absolute" }}
    />
    <Box
      sx={{
        position: "relative",
        display: "flex",
        gap: "1vw",
        px: "2vw",
        py: "0.5vw",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", gap: "1vw", alignItems: "center" }}>
        <img
          src={item?.Player__r?.Photo_URL_1__c || player}
          alt="player"
          style={{
            height: "3vw",
            width: "auto",
            borderRadius: "3vw",
          }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            backgroundImage:
              "radial-gradient(61.24% 43.3% at 50% 50%, #FFF200 0%, #FFF200 26%, #FBB040 97%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: "1.15vw",
            fontStyle: "italic",
            textTransform: "uppercase",
          }}
        >
          {item?.Player__r?.Name}
        </Typography>
      </Box>
      <img
        src={
          item?.Primary_Role__c === "Bowler"
            ? ballIcon
            : item?.Primary_Role__c === "Wicketkeeper"
            ? keeperIcon
            : item?.Primary_Role__c === "All - rounder"
            ? allRounderIcon
            : batIcon
        }
        alt="icon"
        style={{ height: "1.8vw", width: "auto" }}
      />
    </Box>
  </Box>
);

const TeamSquadList = ({ teamDetailsData }: any) => {
  const groupedPlayers = Array.isArray(teamDetailsData)
    ? teamDetailsData.reduce((acc: any, item: any) => {
        const category =
          mapHighestLevelToCategory(item?.Recent_Competitive_Level__c) ||
          "Others";
        if (!acc[category]) acc[category] = [];
        acc[category].push(item);
        return acc;
      }, {})
    : {};

  return (
    <Box
      sx={{
        display: "flex",
        gap: "2vw",
        width: "100%",
        mt: "2vw",
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ flex: 1 }}>
        {groupedPlayers["Icon Player"]?.length > 0 && (
          <>
            <Typography
              variant="h4"
              color="white"
              sx={{ fontSize: "1.2vw", fontWeight: 700, mb: "1vw" }}
            >
              ICON PLAYER ({groupedPlayers["Icon Player"].length})
            </Typography>
            {groupedPlayers["Icon Player"].map((item: any, i: number) => (
              <PlayerCard item={item} key={`icon-${i}`} />
            ))}
          </>
        )}

        {groupedPlayers["Senior Player"]?.length > 0 && (
          <>
            <Typography
              variant="h4"
              color="white"
              sx={{ fontSize: "1.2vw", fontWeight: 700, mb: "1vw", mt: "2vw" }}
            >
              SENIOR PLAYERS ({groupedPlayers["Senior Player"].length})
            </Typography>
            {groupedPlayers["Senior Player"].map((item: any, i: number) => (
              <PlayerCard item={item} key={`senior-${i}`} />
            ))}
          </>
        )}
      </Box>

      <Box sx={{ flex: 1 }}>
        {groupedPlayers["Emerging Player"]?.length > 0 && (
          <>
            <Typography
              variant="h4"
              color="white"
              sx={{ fontSize: "1.2vw", fontWeight: 700, mb: "1vw" }}
            >
              EMERGING PLAYERS ({groupedPlayers["Emerging Player"].length})
            </Typography>
            {groupedPlayers["Emerging Player"].map((item: any, i: number) => (
              <PlayerCard item={item} key={`emerging-${i}`} />
            ))}
          </>
        )}
      </Box>

      <Box sx={{ flex: 1 }}>
        {groupedPlayers["Development Player"]?.length > 0 && (
          <>
            <Typography
              variant="h4"
              color="white"
              sx={{ fontSize: "1.2vw", fontWeight: 700, mb: "1vw" }}
            >
              DEVELOPMENT PLAYERS ({groupedPlayers["Development Player"].length}
              )
            </Typography>
            {groupedPlayers["Development Player"].map(
              (item: any, i: number) => (
                <PlayerCard item={item} key={`dev-${i}`} />
              )
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default TeamSquadList;
